export enum ProductType {
    CHATBOT="CHATBOT",
    AVATAR="AVATAR"
}